var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"f-s-17 font-bold f-c-2 f-f-arial title title-description"},[_vm._v(" "+_vm._s(_vm.$t("message.pd_description"))+" ")]),_c('gap',{attrs:{"height":23.66}}),_c('p',{staticClass:"f-s-12 f-f-arial row-description f-c-1"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }